export const fonts = {
  mosvita: '"Mosvita", sans-serif'
};
